export const ColorsMenu = [
  '#1744ff',
  '#693edd',
  '#1e1f24',
  '#e5484d',
  '#ffc53d',
  '#46a758',
]
